const agentOfficeColumn = () => ({
	name: "agentOffice",
	type: "input" as const,
	placeholder: "Agent Office",
});

export default agentOfficeColumn;
